import apiWrapper from 'common/api/api-wrapper';
import { IAPIErrorContent, ITask } from 'common/api/type-def';

import { ICreateUpdateTask } from 'features/RiskProfile/Taxonomy/api/type-def';

import {
	IGroupParams,
	IGroupDataResponse,
	IUserAndGroup,
	ISubPartCitationDetails,
	ICitationsUpdateRequest,
	IGroupsTableResponse,
	IGroupAssessmentUpdateRequest,
	IGroupsDataParams,
	IGroupCitationDetails,
	IGroupsTableList,
	ITablePaginationParams,
	IEditGroupParams,
	ISummary,
	IObligationsForSummary,
	IBusiness,
	IAssignedUsers,
	IBusinessUnit,
	IBusinessUnitMappingEntity,
	IUpdateBusinessUnitMappingEntity,
	IRegInventoryFilterHeaders,
	IRegulationRelationshipMapping,
	IMappingStatusCount,
	IRelationshipMappingRegenerate,
	IRegenerateResponse,
	ICurrentInventoryRequestHeaders,
	IRegulatoryInventoryCard,
	IBuildCard,
	IGetRegInvRelationshipRequestParams,
	ICitationSummaryData,
	IFilterSearchWords,
} from './type-def';

const REG_CHANGE_DOMAIN_SERVICE_URL =
	process.env.REACT_APP_REG_CHANGE_DOMAIN_SERVICE_URL;
const REG_INV_URL = process.env.REACT_APP_REG_INVENTORY_DOMAIN_SERVICE_URL;

export const getGroupCitationDetails = async (groupId: string) => {
	const resp = await apiWrapper.get<IGroupCitationDetails, IAPIErrorContent>(
		`${REG_INV_URL}/group/${groupId}`,
	);
	return resp;
};

export const getCitationDetails = async (param: string) => {
	const resp = await apiWrapper.get<ISubPartCitationDetails, IAPIErrorContent>(
		`${REG_INV_URL}/applicability-assessment/${param}`,
	);
	return resp;
};
export const getAllUserAndGroupsDetails = async (roleName: string) => {
	const resp = await apiWrapper.get<IUserAndGroup>(
		`${process.env.REACT_APP_USER_SERVICE_URL}/role/user-group?roleName=${roleName}`,
	);
	return resp;
};

export const updateCitationsDetailsPost = async (
	data: ICitationsUpdateRequest,
) => {
	const resp = await apiWrapper.post<ICitationsUpdateRequest, IAPIErrorContent>(
		`${REG_INV_URL}/applicability-assessment`,
		data,
	);
	return resp;
};

export const updateCitationsDetailsPut = async (
	data: ICitationsUpdateRequest,
) => {
	const resp = await apiWrapper.put<ICitationsUpdateRequest, IAPIErrorContent>(
		`${REG_INV_URL}/applicability-assessment`,
		data,
	);
	return resp;
};

export const createGroupDataApi = async (data: IGroupParams) => {
	const resp = await apiWrapper.post<IGroupDataResponse | IAPIErrorContent>(
		`${REG_INV_URL}/group`,
		data,
	);
	return resp;
};

export const putGroupAssessment = async (
	data: IGroupAssessmentUpdateRequest,
) => {
	const resp = await apiWrapper.put<
		IGroupAssessmentUpdateRequest,
		IAPIErrorContent
	>(`${REG_INV_URL}/group-assignment/group`, data);
	return resp;
};

// not used
export const getGropuingTabGroupsData = async (params: any) => {
	const sortKey = params?.sortKey ? params?.sortKey : '';
	const sortDirection = params?.sortDirection ? params?.sortDirection : '';
	const resp = await apiWrapper.get<IGroupsTableResponse, IAPIErrorContent>(
		`${REG_INV_URL}/group?pageNumber=${params?.pageNumber}&pageSize=${params?.pageSize}&sortBy=${sortKey}&sortOrderBy=${sortDirection}`,
	);
	return resp;
};

export const postGroupAssessment = async (
	data: IGroupAssessmentUpdateRequest,
) => {
	const resp = await apiWrapper.post<
		IGroupAssessmentUpdateRequest,
		IAPIErrorContent
	>(`${REG_INV_URL}/group-assignment/group`, data);
	return resp;
};

export const fetchGroupsSummaryAPIData = async (
	searchText: string,
	params: ITablePaginationParams,
	data: IGroupsDataParams,
) => {
	const sortKey = params?.sortKey ? params?.sortKey : '';
	const sortDirection = params?.sortDirection ? params?.sortDirection : '';
	const resp = await apiWrapper.post<IGroupsTableResponse, IAPIErrorContent>(
		`${REG_INV_URL}/group/status?searchText=${searchText}&pageNumber=${params?.pageNumber}&pageSize=${params?.pageSize}&sortBy=${sortKey}&sortOrderBy=${sortDirection}`,
		data,
	);
	return resp;
};

export const getSummaryAssessmentData = async (param: string) => {
	const resp = await apiWrapper.get<IGroupCitationDetails, IAPIErrorContent>(
		`${REG_INV_URL}/group/${param}`,
	);
	return resp;
};
export const updateGroupDataApi = async (
	data: IEditGroupParams,
	groupId: string,
) => {
	const resp = await apiWrapper.put<IGroupDataResponse | IAPIErrorContent>(
		`${REG_INV_URL}/group/${groupId}`,
		data,
	);
	return resp;
};

export const deleteGroupDataApi = async (
	data: IGroupsTableList,
	groupId: string,
) => {
	const resp = await apiWrapper.delete<IGroupDataResponse | IAPIErrorContent>(
		`${REG_INV_URL}/group/${groupId}`,
		data,
	);
	return resp;
};

export const updateCitationWithSummary = async (data: ICitationSummaryData) => {
	const resp = await apiWrapper.post<ICitationSummaryData, IAPIErrorContent>(
		`${REG_INV_URL}/summary-assessment`,
		data,
	);
	return resp;
};

export const generateSummary = async (
	data: IObligationsForSummary,
	groupId: string,
) => {
	const resp = await apiWrapper.post<ISummary | IAPIErrorContent>(
		`${REG_INV_URL}/summary-assessment/plain-language-summary/${groupId}?regenerate=true`,
		data,
	);
	return resp;
};

export const editSummary = async (data: ISummary, groupId: string) => {
	const resp = await apiWrapper.put<ISummary | IAPIErrorContent>(
		`${REG_INV_URL}/summary-assessment/plain-language-summary/${groupId}`,
		data,
	);
	return resp;
};

export const editBusinessUnits = async (data: IBusinessUnit[]) => {
	const resp = await apiWrapper.post<IBusinessUnit[] | IAPIErrorContent>(
		`${REG_INV_URL}/group/business-unit`,
		data,
	);
	return resp;
};

export const getAllBusinessUnits = async () => {
	const resp = await apiWrapper.get<IBusiness[] | IAPIErrorContent>(
		`${REG_INV_URL}/business-units`,
	);
	return resp;
};

export const getAssociatedAssignedToUsers = async (unitId: string) => {
	const resp = await apiWrapper.get<IAssignedUsers[] | IAPIErrorContent>(
		`${REG_INV_URL}/business-unit/${unitId}/assigned-users`,
	);
	return resp;
};

export const getRegInvRelationshipData = async (
	params: IGetRegInvRelationshipRequestParams,
) => {
	const sort =
		params?.sortParam !== '' ? `${params?.sortParam},${params?.sortOrder}` : '';
	const resp = await apiWrapper.get<
		IRegulationRelationshipMapping | IAPIErrorContent
	>(
		`${REG_INV_URL}/card-details?parentObjectId=${
			params?.citationGroupId
		}&page=${params?.pageNumber}&size=${
			params?.pageSize
		}&sort=${sort}&searchText=${
			params?.searchText !== '' ? params?.searchText : ''
		}`,
	);
	return resp;
};

export const getMappingStatusCount = async (id: string) => {
	const resp = await apiWrapper.get<IMappingStatusCount | IAPIErrorContent>(
		`${REG_INV_URL}/relationship/status/count/${id}`,
	);
	return resp;
};

export const getRegInventoryHorizonStatus = async (
	groupId: string,
	regulationId: string,
) => {
	const resp = await apiWrapper.get<string | IAPIErrorContent>(
		`${REG_INV_URL}/horizon/relationships/status/${groupId}/${regulationId}`,
	);
	return resp;
};

export const getMappingDetailsData = async (groupId: string) => {
	const resp = await apiWrapper.get<IBusinessUnitMappingEntity[]>(
		`${REG_INV_URL}/group/${groupId}/mapping-assessment`,
	);
	return resp;
};

export const postInventoryMappingStatus = async (
	data: IBusinessUnitMappingEntity[],
	groupId: string,
) => {
	const resp = await apiWrapper.post<
		IBusinessUnitMappingEntity[] | IAPIErrorContent
	>(`${REG_INV_URL}/group/${groupId}/mapping-assessment`, data);
	return resp;
};

export const putInventoryMappingStatus = async (
	data: IUpdateBusinessUnitMappingEntity,
	groupId: string,
) => {
	const resp = await apiWrapper.put<
		IUpdateBusinessUnitMappingEntity | IAPIErrorContent
	>(`${REG_INV_URL}/group/${groupId}/mapping-assessment`, data);
	return resp;
};

export const getFilterItemList = async (data: IRegInventoryFilterHeaders) => {
	const resp = await apiWrapper.post<IFilterSearchWords[] | IAPIErrorContent>(
		`${process.env.REACT_APP_REG_CHANGE_DOMAIN_SERVICE_URL}/elastic-search/search-by-field`,
		data,
	);
	return resp;
};

export const getCurrentInventoryCardCount = async (
	headers: ICurrentInventoryRequestHeaders,
) => {
	let url: string;
	if (headers.loggedInUser) {
		url = `${REG_INV_URL}/counts/current-inventory`;
	} else {
		url = `${REG_INV_URL}/counts/build-inventory`;
	}
	const resp = await apiWrapper.post<
		IRegulatoryInventoryCard | IBuildCard | IAPIErrorContent
	>(url, headers);
	return resp;
};

export const postMappingGenerate = async (
	data: IRelationshipMappingRegenerate,
) => {
	const resp = await apiWrapper.post<IRegenerateResponse>(
		`${REG_INV_URL}/entity/summary/generate`,
		data,
	);
	return resp;
};

export const updateBulkTask = async (data: ITask[]) => {
	const postData = {
		taskRequestList: data,
	};
	const resp = await apiWrapper.put<ICreateUpdateTask, IAPIErrorContent>(
		`${REG_CHANGE_DOMAIN_SERVICE_URL}/task-manager/task`,
		postData,
	);
	return resp;
};
